<div mat-dialog-title>
    <h6>Select Roadbooks</h6>
    <h6 class="mt-3"><button mat-button (click)="currentFolder = null; selectedFolder = null; updateFolderTree()"><mat-icon>home</mat-icon></button>
        <ng-container *ngFor="let fi of pathFolders">/<button mat-button (click)="currentFolder = fi.i; selectedFolder = null; updateFolderTree()">{{ fi.n }}</button></ng-container>
    </h6>
</div>
<div mat-dialog-content class="border-top border-bottom p-0">
    <mat-list role="list" class="mb-3">
        <mat-list-item role="listitem" class="pointer" *ngFor="let fi of currentFolders" (click)="selectedFolder = fi.i" [ngClass]="{'selected': selectedFolder === fi.i }">
            <div class="w-100 h-100 d-flex" style="align-items: center;">
                <mat-icon class="mr-3">folder</mat-icon><span>{{ fi.n }}</span>
            </div>
            <button mat-button *ngIf="isParent(fi)" class="px-0 text-right" style="min-width: 0; float:right;" (click)="selectedFolder = null; currentFolder = fi.i; updateFolderTree()"><mat-icon>arrow_forward</mat-icon></button>
        </mat-list-item>
    </mat-list>
</div>
<div mat-dialog-actions>
    <button [mat-dialog-close]="selectedFolder" cdkFocusInitial class="btn btn-success" [disabled]="!selectedFolder">Select</button>
    <button style="margin-left: 20px" (click)="cancel()" class="btn btn-danger">Cancel</button>
</div>